"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HttpResponse {
    constructor(status, response) {
        this.status = status;
        this.response = response;
    }
}
exports.HttpResponse = HttpResponse;
//# sourceMappingURL=httpResponse.js.map